import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

export const firebaseDevConfig = {
    description: "Development",
    apiKey: "AIzaSyDH7H1CL59EbC_EJFs95dl7kH58eYDfcwI",
    authDomain: "diffusitron-dev-c62d6.firebaseapp.com",
    databaseURL: "https://diffusitron-dev-c62d6-default-rtdb.firebaseio.com",
    projectId: "diffusitron-dev-c62d6",
    storageBucket: "diffusitron-dev-c62d6.appspot.com",
    messagingSenderId: "529934710841",
    appId: "1:571827831739:ios:9657889e3ae051b9957a9e",
    measurementId: "G-G1LVGK2F6D"
};

export const firebaseProdConfig = {
    description: "Production",
    apiKey: "AIzaSyA_yNJGCcSv5IG9JXEESAipl-ELA_Ydfc8",
    authDomain: "diffusitron-prod.firebaseapp.com",
    databaseURL: "https://diffusitron-prod-default-rtdb.firebaseio.com",
    projectId: "diffusitron-prod",
    storageBucket: "diffusitron-prod.appspot.com",
    messagingSenderId: "26011306565",
    appId: "1:26011306565:web:e441cff19d2a8cc2ca712c",
    measurementId: "G-RT6LM40YNP"
};

export const getFirebaseConfig = (environment) => {
    return environment === 'development' ? firebaseDevConfig : firebaseProdConfig;
};

// Get the initial environment from localStorage
const getInitialEnvironment = () => {
    return window.localStorage.getItem('firebase-env') || 'production';
};

// Initialize Firebase with the saved environment
const initialConfig = getFirebaseConfig(getInitialEnvironment());
export const firebase = initializeApp(initialConfig);

export const auth = getAuth(firebase);
export const db = getFirestore(firebase, 'diffie-economy');
export const bucketStorage = getStorage(
    firebase,
    getInitialEnvironment() === 'development'
        ? 'gs://diffusitron-dev-c62d6.appspot.com'
        : 'gs://diffusitron-prod.appspot.com'
);
